import { actionTypes } from '../actions/params';

// DEFAULT STATE
export const initParams = {
  ticker: '',
  loggedIn: false,
  email: '',
  isStarted: false,
  latestRefreshSeconds: 5,
  historyRefreshSeconds: 300,
};

// WRITES
const params = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.SET_TICKER:
      return Object.assign({}, state, {
        ticker: action.value,
      });
    case actionTypes.SET_LOGGED_IN:
      return Object.assign({}, state, {
        loggedIn: action.value,
      });
    case actionTypes.SET_EMAIL:
      return Object.assign({}, state, {
        email: action.value,
      });
    case actionTypes.SET_IS_STARTED:
      return Object.assign({}, state, {
        isStarted: action.value,
      });
    default:
      return state;
  }
};

// READS
export const getTicker = (state) => state.params.ticker;
export const getEmail = (state) => state.params.email;
export const getIsLoggedIn = (state) => state.params.loggedIn;
export const getIsStarted = (state) => state.params.isStarted;
export const getLatestRefreshSeconds = (state) => state.params.latestRefreshSeconds;
export const getHistoryRefreshSeconds = (state) => state.params.historyRefreshSeconds;

export default params;



// WEBPACK FOOTER //
// ./src/reducers/params.js